import React from "react";

export const Logo = ({ dark = false, className = "" }) => {
  const ink = dark ? "#ffffff" : "var(--pt-ink)";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="logo">
      <img
        src="/powertech-mark.png?v=1"
        alt="PowerTech"
        className="h-9 w-auto select-none"
        draggable="false"
      />
      <span className="font-display font-extrabold tracking-tight leading-none text-[19px]">
        <span style={{ color: ink }}>Power</span>
        <span style={{ color: "var(--pt-blue)" }}>Tech</span>
      </span>
    </div>
  );
};
